export function priceDivide(priceString) {
  let integer;
  let decimal;
  let isNegative;
  let separatedPrice;

  priceString = typeof priceString === 'string' ? priceString : priceString.toString();
  
  if (priceString.length === 0) {
    return '';
  }

  decimal = getDecimal(priceString);
  integer = parseInt(priceString, 10);

  isNegative = integer < 0;

  integer = Math.abs(integer);  
  separatedPrice = integer.toString().replace(/(\d{1,3})(?=((\d{3})*)$)/g, " $1").trim();

  separatedPrice = separatedPrice.concat(decimal);

  return isNegative ? '-' + separatedPrice : separatedPrice;
}

function getDecimal(num) {
  let str = '' + num;
  const zeroPos = str.indexOf(".");
  
  if (zeroPos === -1) {
    return '';
  }

  str = str.slice(zeroPos);
  return str;
}


// WEBPACK FOOTER //
// ./src/services/priceDivide.js